// The door to What's New from anywhere under the app's layout. The dialog's
// open state lives in AppLayout (it shows itself once per release); this hands
// down only the way to open it, so the account menu can carry a row to it
// without the header in between knowing.

import { type ReactNode, createContext, useContext } from 'react'

const WhatsNewContext = createContext<(() => void) | null>(null)

export function WhatsNewProvider({ open, children }: { open: () => void; children: ReactNode }) {
  return <WhatsNewContext.Provider value={open}>{children}</WhatsNewContext.Provider>
}

/** Opens the What's New dialog; null outside the app's layout (a surface
 *  drawn alone draws no door it cannot open). */
export function useOptionalWhatsNew(): (() => void) | null {
  return useContext(WhatsNewContext)
}
